import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Role} from 'app/core/domain/role';
import {FxService} from 'app/core/service/fx.service';
import {FX} from 'app/core/domain/fx';
import {RoleService} from 'app/core/service/role.service';
import {Message} from 'primeng/components/common/api';
import {GlobalAppService} from 'app/core/commons/global-app.service';
import {MessageSeverity} from '../../../core/commons/message-severity';
import {Router, ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-role',
    templateUrl: './role-form.component.html',
    styleUrls: ['./role-form.component.scss'],
    providers: [FxService, RoleService]
})
export class RoleFormComponent implements OnInit, OnDestroy {

    role: Role = null;
    title = '';

    constructor(private roleService: RoleService,
                private appService: GlobalAppService,
                private router: Router,
                private route: ActivatedRoute,
                private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        const $id = this.route.params
            .map(params => params['id']);

        $id.filter(id => id !== 'new')
            .switchMap(id => this.roleService.get(+id))
            .subscribe(
                role => {
                    this.role = role;
                    this.title = 'Editar el rol';
                    this.cd.markForCheck();
                },
                error => {
                    this.appService.sendMsg(
                        MessageSeverity.ERROR,
                        'Error:',
                        'El rol no existe en el sistema.'
                    );
                    this.router.navigate(['home', 'role']);
                }
            );

        $id.filter(id => id === 'new')
            .subscribe(role => {
                    this.title = 'Nuevo rol';
                    this.role = new Role();
                    this.cd.markForCheck()
                }
            );
    }

    ngOnDestroy(): void {
    }

    public saveRol() {
        if ((this.role.name !== '') && (this.role.fxs.length > 0)) {
            this.appService.setLoading(true);
            if (this.role.id) {
                this.roleService.update(this.role)
                    .subscribe(success => {
                        this.appService.setLoading(false);
                        this.appService.sendMsg(
                            MessageSeverity.SUCCESS, 'Guardado',
                            'El Rol ha sido guardado correctamente.'
                        );
                        this.router.navigate(['home', 'role']);
                    },
                    error => {
                        this.appService.setLoading(false);
                        this.appService.sendMsg(
                            MessageSeverity.ERROR, 'Error',
                            'No se a podido guardar el Rol. ' + error.json().message
                        )
                    }
                );
            } else {
                this.roleService.create(this.role)
                    .subscribe(
                        success => {
                            this.appService.setLoading(false);
                            this.appService.sendMsg(
                                MessageSeverity.SUCCESS,
                                'Exito',
                                'El rol ha sido creado correctamente.');
                            this.router.navigate(['home', 'role']);
                        },
                        error => {
                            this.appService.setLoading(false);
                            this.appService.sendMsg(
                                MessageSeverity.ERROR,
                                'Error:',
                                'No se a podido crear el nuevo rol. ' + error.json().message
                            )
                        }
                    );
            }
        } else {
            this.appService.sendMsg(MessageSeverity.ERROR, 'Error', 'Los datos son invalidos.');
        }
    }

    public addFx(fx) {
        this.role.fxs.push(new FX(fx));
    }

    public goBack() {
        this.router.navigate(['home', 'role']);
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/roles/role-form/role-form.component.ts